import Domains from '@lcsc-ui/utils/domains';

const _loadQQ = (qqNum) => {
  if (qqNum === '2355775601') {
    qqNum = '4000800709';
  }
  let _qqUrl = Domains.lcscQqUrl + '/onlineQQ.html?' + (qqNum || '4000800709');
  let bigQqWin = true;

  const qqNums = ['2852512828', '800822815', '800850981', '800822581', '800821892', '800821856'];
  const bigWinQqNums = ['4000800709', '800156618', '800135181', '800136682', '800135182'];

  if (qqNums.indexOf(qqNum) !== -1) {
    _qqUrl = 'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true';
  }
  if (bigWinQqNums.indexOf(qqNum) !== -1) {
    _qqUrl = 'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true';
    bigQqWin = false;
  }

  const name = 'qqWindow';
  let iHeight = 600;
  let iWidth = 750;
  if (bigQqWin) {
    iHeight = 595;
    iWidth = 740;
  }
  const iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
  const iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
  window.open(
    _qqUrl,
    name,
    'height=' +
      iHeight +
      ',innerHeight=' +
      iHeight +
      ',width=' +
      iWidth +
      ',innerWidth=' +
      iWidth +
      ',top=' +
      iTop +
      ',left=' +
      iLeft +
      ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
  );
};

const formatParams = (params) => {
  const sendParams = {};
  Object.keys(params).forEach((item) => {
    if (
      (params[item] && Array.isArray(params[item]) && params[item].length > 0) ||
      (!Array.isArray(params[item]) && params[item] !== null && params[item] !== undefined && params[item] !== '')
    ) {
      sendParams[item] = params[item];
    }
  });
  return sendParams;
};

const formatNumberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getIsLgScreen = () => {
  const width = window.innerWidth;
  if (width >= 1552) {
    return true;
  }
  return false;
};

const formatNameMap = (arr, nameKey = 'name', valueKey = 'code') => {
  const obj = {};
  arr.forEach((item) => {
    obj[item[valueKey]] = item[nameKey];
  });
  return obj;
};

const generatePaginationArray = (totalPages, currentPage, displayRange = 5) => {
  const paginationArray = [];
  paginationArray.push(1);
  if (currentPage > displayRange + 2) {
    paginationArray.push('...');
  }
  for (let i = Math.max(2, currentPage - displayRange); i < currentPage; i++) {
    paginationArray.push(i);
  }
  if (currentPage !== 1 && currentPage !== totalPages) {
    paginationArray.push(currentPage);
  }
  for (let i = currentPage + 1; i <= Math.min(totalPages - 1, currentPage + displayRange); i++) {
    paginationArray.push(i);
  }
  if (currentPage < totalPages - displayRange - 1) {
    paginationArray.push('...');
  }
  if (totalPages > 1) {
    paginationArray.push(totalPages);
  }
  return paginationArray;
};

const getCurrentPageUrl = (currentUrl, page) => {
  const pageNum = getQueryParam(currentUrl, 'page');
  let href = pageNum ? currentUrl.replace(`?page=${pageNum}`, '').replace(`&page=${pageNum}`, '') : currentUrl;
  if (page === 1 || page === 0) {
    return href;
  }
  if (href.includes('?')) {
    href += '&page=' + page;
  } else {
    href += '?page=' + page;
  }
  return href;
};

const getQueryParam = (url, param) => {
  const regex = new RegExp(`[?&]${param}=([^&#]*)`, 'i');
  const result = regex.exec(url);
  return result ? result[1] : null;
};

const getPaginationInfo = ({ currentUrl, currentPage, countPage, totalCount, pageSize = 30 }) => {
  const maxCountPage = countPage > 50 ? 50 : countPage;
  const paginationPages = [];
  const list = generatePaginationArray(Number(maxCountPage), Number(currentPage), 5);
  list.forEach((item) => {
    paginationPages.push({
      page: item,
      href: item !== '...' ? getCurrentPageUrl(currentUrl, item) : '',
    });
  });
  return {
    currentPage,
    countPage: maxCountPage,
    paginationPages,
    prevHref: getCurrentPageUrl(currentUrl, currentPage - 1),
    nextHref: getCurrentPageUrl(currentUrl, currentPage + 1),
    total: totalCount,
    pageSize: pageSize,
  };
};

function isNotEmpty(val) {
  return val !== null && val !== undefined && val !== '';
}

// 计算小数点后有几位
const countDecimalPlaces = (num) => {
  const numStr = num.toString();
  const decimalIndex = numStr.indexOf('.');
  if (decimalIndex === -1) {
    return 0;
  }
  return numStr.length - decimalIndex - 1;
};

export {
  _loadQQ,
  formatParams,
  formatNumberWithCommas,
  getIsLgScreen,
  formatNameMap,
  generatePaginationArray,
  getCurrentPageUrl,
  getQueryParam,
  getPaginationInfo,
  isNotEmpty,
  countDecimalPlaces,
};
